import React from 'react';
// import '../styles/MissingRoute.sass';

const MissingRoute = () => (
  <section className="MissingRoute">
    <h1>Missing Route</h1>
    <p>{"Unfortunately, we could not find the page you're looking for."}</p>
  </section>
);

export default MissingRoute;



// WEBPACK FOOTER //
// ./src/components/MissingRoute.js